<div class="VizseekTitle">
    <span>{{'common.vizseek_Search_results'| cxTranslate}}</span>
    <button class="dialog-close-btn" aria-label="close dialog" mat-dialog-close>
        <img src="/icons/close-kb.svg" alt="" class="close" width="20" />
    </button>
</div>
<mat-dialog-content class="vizseekContent" >
  
        <div class="vizseek_popup mt-3"> 
           <p>{{'common.vizseek_Search_category'| cxTranslate}}
                <button class="btn button"  mat-dialog-close (click)="FeedBack('yes')">
                    {{'common.text_quote_yes_button_label'|cxTranslate}}</button>
                    <button class="btn button-launch " mat-dialog-close (click)="FeedBack('no')">
                        {{'common.text_warranty_submit_labourrequested_no'|cxTranslate}}</button>
                {{'common.vizseek_Search_category_info'|cxTranslate}}
                <a href="https://n0c357rmy1njbuit2friqwu.blob.core.windows.net/documents/gIJArKnXI0EBhB_Y497499_EN_000.pdf" target="_blank">
                    {{'common.Vizseek_Search_Guide'|cxTranslate}}   
                    <img src="/icons/pdf-grey.svg" alt="" class="PDF" width="20" />                      
            </a>
        </p>
        </div>      

    
</mat-dialog-content>